import type { Routes } from '@angular/router';

import type { AggregatedClientsRouteData } from '#modules/clients/models/aggregated-clients.interfaces';

export const AGGREGATED_CLIENTS_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#modules/clients/layouts/aggregated-clients-layout/aggregated-clients-layout.component').then(
                (m) => m.AggregatedClientsLayoutComponent
            ),
        data: { isFrom: 'aggregated' } satisfies AggregatedClientsRouteData,
    },
];
